import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Page from 'components/system/Page';
import Paper from 'components/system/Paper';
import colors from 'styles/colors';
import Container from '@mui/material/Container';

const TeamRestrictionNote = () => (
  <Container>
    <Page title="Team">
      <Grid container direction="row" spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ paddingTop: '40px', paddingBottom: '40px', textAlign: 'center' }}>
            <Typography type="h5" color={colors.text.primary}>
              Click the toggle in the top bar to switch to your team mode.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Page>
  </Container>
);

export default TeamRestrictionNote;
